export default "__VITE_ASSET__5600d794__"